import apiService from './api.service';
import { MyQuota } from '@/types/agents';

class QuotaService {
  async getMyQuota(): Promise<MyQuota> {
    const response = await apiService.get<MyQuota>('/agents/quota/me/');
    return response.data;
  }

  async requestIncrease(payload: {
    reason: string;
    requested_field: string;
    suggested_value?: number;
  }): Promise<void> {
    await apiService.post('/agents/quota/requests/', payload);
  }
}

export default new QuotaService();
